import { useContext } from 'react';
import { useLocation } from 'react-router';
import { LayoutContext } from '../context';
import LKPage from '../content/Manager/LKPage';
import LKPageSurveyor from '../content/Surveyor/LKPageSurveyor';
import LKPageDraftsman from '../content/Draftsman/LKPageDraftsman';
import { canAccessPath, isDraftsman, isSurveyor } from '../roles';
import LKPageQuality from '../content/Quality/LKPageQuality';
import NoAccessPage from '../pages/NoAccessPage';

export default function RoleLayout() {
    const { effectiveRole, account } = useContext(LayoutContext);
    const { pathname } = useLocation();

    const permissionPath = ['/settings', '/access'].some(path => pathname === path || pathname.startsWith(`${path}/`));
    if (!effectiveRole && !(permissionPath && canAccessPath(pathname, { account, activeRole: effectiveRole }))) return <NoAccessPage />;
    if (effectiveRole === 'quality_master') return <LKPageQuality />;
    if (isDraftsman(effectiveRole)) return <LKPageDraftsman />;
    if (isSurveyor(effectiveRole)) return <LKPageSurveyor />;
    return <LKPage />;
}